export const LANG_EN = {
	RESTART: 'Restart',
	UNDO: 'Undo',
	PAUSE: 'Pause',
	HINT: 'Hint',
	STONES: 'Stones',
	FREE: 'Free',
	FULLSCREEN: 'Fullscreen',
	HINT_LONG: 'Show possible moves',
	UNDO_LONG: 'Undo last move',
	RESTART_LONG: 'Start a new game',
	PAUSE_LONG: 'Continue/Pause game',
	MSG_CONTINUE_PAUSE: 'Continue Game',
	MSG_CONTINUE_SAVE: 'Continue Saved Game',
	MSG_START: 'Start Game',
	MSG_PLAY_AGAIN: 'Play again',
	MSG_BEST: 'Congratulations, new best time!',
	MSG_GOOD: 'Well done!',
	MSG_FAIL: 'No more matching tiles.',
	STATS_GAMES: 'Nr. of Games',
	STATS_BEST: 'Best time',
	LICENSE: 'License',
	SHORTCUTS: 'Shortcuts',
	SETTINGS: 'Settings',
	STATS: 'Stats',
	MODE: 'Board Fill Algorithm',
	MODE_SOLVABLE: 'Solvable',
	MODE_LINEAR: 'Linear',
	MODE_RANDOM: 'Random',
	AUDIO: 'Audio',
	AUDIO_SOUNDS: 'Sounds',
	AUDIO_MUSIC: 'Music',
	LANG: 'Language',
	LANG_EN: 'English',
	LANG_PT: 'Portuguese',
	LANG_AUTO: '[Default]',
	OPEN_SETTINGS: 'Click here to open the settings',
	OPEN_HELP: 'Click here to open the help dialog',
	READ_MORE_WIKIPEDIA: 'Read more on wikipedia',
	READ_MORE_WIKIPEDIA_URL: 'https://en.wikipedia.org/wiki/Mahjong_tiles',
	TILES_INFO: 'Tiles Information',
	MODE_SOLVABLE_DESC: 'A random fill with at least one solving possibility',
	MODE_RANDOM_DESC: 'A total random fill, maybe unsolvable',
	MODE_LINEAR_DESC: 'A backwards fill, always solvable, maybe boring to experienced players',
	BOARD_GENERATOR: 'Board Generator',
	START_SELECTED: 'Start Selected',
	START_RANDOM: 'Start Random',
	TILESET: 'Tileset Art',
	BACKGROUND: 'Background',
	INFO: 'Info'
};

export const LANG_PT = {
	RESTART: 'Novo Jogo',
	UNDO: 'Voltar',
	PAUSE: 'Pausar',
	HINT: 'Dica',
	STONES: 'Peças',
	FREE: 'Livres',
	FULLSCREEN: 'Tela Cheia',
	SETTINGS: 'Configurações',
	HINT_LONG: 'Mostrar movimentos possíveis',
	UNDO_LONG: 'Desfazer última jogada',
	RESTART_LONG: 'Começar um novo jogo',
	PAUSE_LONG: 'Continuar/Pausar jogo',
	MSG_CONTINUE_PAUSE: 'Continuar',
	MSG_CONTINUE_SAVE: 'Continuar Jogo Salvo',
	MSG_START: 'Começar',
	MSG_PLAY_AGAIN: 'Jogar novamente',
	MSG_BEST: 'Parabéns, novo tempo recorde!',
	MSG_GOOD: 'Parabéns!',
	MSG_FAIL: 'Não há mais peças livres.',
	STATS_GAMES: 'N. de Jogos',
	STATS_BEST: 'Melhor tempo',
	LICENSE: 'Licensa',
	SHORTCUTS: 'Atalhos',
	STATS: 'Estatísticas',
	MODE: 'Board Fill Algorithm',
	MODE_SOLVABLE: 'Solvable',
	MODE_LINEAR: 'Linear',
	MODE_RANDOM: 'Random',
	AUDIO: 'Áudio',
	AUDIO_SOUNDS: 'Sons',
	AUDIO_MUSIC: 'Música',
	LANG: 'Language',
	LANG_EN: 'Inglês',
	LANG_PT: 'Português',
	LANG_AUTO: '[Padrão]',
	OPEN_SETTINGS: 'Clique aqui para abrir as configurações',
	OPEN_HELP: 'Clique aqui para abrir a ajuda',
	READ_MORE_WIKIPEDIA: 'Read more on wikipedia',
	READ_MORE_WIKIPEDIA_URL: 'https://en.wikipedia.org/wiki/Mahjong_tiles',
	TILES_INFO: 'Informações sobre as peças',
	MODE_SOLVABLE_DESC: 'A random fill with at least one solving possibility',
	MODE_RANDOM_DESC: 'A total random fill, maybe unsolvable',
	MODE_LINEAR_DESC: 'A backwards fill, always solvable, maybe boring to experienced players',
	BOARD_GENERATOR: 'Board Generator',
	START_SELECTED: 'Jogar Selecionado',
	START_RANDOM: 'Jogar Aleatório',
	TILESET: 'Peças',
	BACKGROUND: 'Papel de Parede',
	INFO: 'Info'
};
